import { atomWithReset } from "jotai/utils";

// Global flag to indicate whether Save should be disabled
// Usage: const [saveDisabled, setSaveDisabled] = useAtom(saveDisabledAtom);
// setSaveDisabled(true) to disable, setSaveDisabled(false) to enable,
// or use reset() if you prefer default behavior.
export const saveDisabledAtom = atomWithReset(false);
